module.exports = __webpack_public_path__ + "img/usdtcoin.00e5f4b4.png";